import { useRouter } from 'next/router'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { useApiGetKsPeriodikList } from 'api/kinerja/kepala-sekolah/dinas/penilaian-periodik'
import { Header } from 'app/KinerjaShared/components/Header'
import { HeaderPanelBase } from 'app/KinerjaShared/components/HeaderPanelBase'
import { TablePeriodik } from 'app/KinerjaShared/components/Periodik/TablePeriodik'
import { PENGELOLAAN_KINERJA_KADIN_PATH } from 'app/KinerjaShared/constants/path'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import {
  PANDUAN_PENILAIAN_PERIODIK_WITH_RECOMMENDATION_URL,
  PANDUAN_PENILAIAN_PERIODIK_WITHOUT_RECOMMENDATION_URL,
} from 'app/KinerjaShared/utils/panduan'
import usePenilaianPeriodikTrackEvent from 'app/KinerjaShared/hooks/usePenilaianPeriodikTrackEvent'

export function DaftarPenilaianPeriodikKs() {
  const { periodYear } = usePeriodContext()
  const router = useRouter()

  // ---------------------------
  // Get periodic list
  // ---------------------------
  const { data, isLoading } = useApiGetKsPeriodikList({
    params: { skpYear: periodYear },
    options: {
      enabled: Number.isInteger(periodYear),
      staleTime: 60 * 60 * 1000, // 1 hour
    },
  })
  const items = data?.data?.periods ?? []
  const hasRecommendation = data?.meta?.nilaiRekomendasi

  // ---------------------------
  // Handle tracker
  // ---------------------------
  const { trackEvent } = usePenilaianPeriodikTrackEvent()

  // Handle tracker for detail CTA
  const handleTrackDetailCta = (month: number) => {
    trackEvent({
      activity_type: 'choose_period',
      screen_name: 'penilaian_periodik',
      attributes: {
        year: periodYear,
        month,
        role: 'dinas',
        system_type: hasRecommendation ? 'rekomendasi' : 'manual',
      },
    })
  }

  return (
    <div className="px-8 pb-8 pt-12 bg-gray-10 min-h-full">
      <div className="max-w-6xl mx-auto pb-12">
        <Header
          title="Penilaian Periodik"
          className="mb-12"
          rightNode={
            <HeaderPanelBase>
              <a
                className="flex items-center space-x-1 text-blue-70"
                href={
                  hasRecommendation
                    ? PANDUAN_PENILAIAN_PERIODIK_WITH_RECOMMENDATION_URL
                    : PANDUAN_PENILAIAN_PERIODIK_WITHOUT_RECOMMENDATION_URL
                }
                target="blank"
              >
                <Icon color="inherit">help</Icon>
                <Text as="span" variant="action" color="inherit">
                  Cek Pusat Informasi
                </Text>
              </a>
            </HeaderPanelBase>
          }
          onBack={() => {
            // Navigate to a specific page to avoid back button issue
            // e.g. new tab or window that initiated a new browsing context
            router.push(PENGELOLAAN_KINERJA_KADIN_PATH)
          }}
        />

        <main>
          <div className="p-4 mb-8 bg-cyan-5 border border-blue-70 rounded gap-2 flex mt-6">
            <Icon>info</Icon>
            <Text>
              Data Penilaian Periodik untuk periode sebelumnya sudah tersedia
              dan hanya dapat dicek di E-Kinerja.
            </Text>
          </div>

          <TablePeriodik
            isLoading={isLoading}
            items={items}
            // Always hide since autosend is not available. Consider to remove it completely in the future.
            showAutosendColumn={false}
            nextPageResolver={(month) =>
              `${PENGELOLAAN_KINERJA_KADIN_PATH}/periodik/${month}`
            }
            onClickDetailCta={handleTrackDetailCta}
          />
        </main>
      </div>
    </div>
  )
}
